import { isEmptyStr } from "js/common";
import { v4 as uuidv4 } from "uuid";

// 시각 입력
export default function TimeInput({ name, value, style, onChange, readOnly, placeholder = "00:00" }) {

	const timeInputChange = (e) => {
        const { value } = e.target;

		const formatVal = formatTime(value);	// 입력값을 날짜 format으로 변경

		e.target.value = formatVal;
		onChange && onChange(e);	// 위로 전달. 그래야 입력값이 화면에 표시됨.
	}
	
	const formatTime = (value) => {
		if(isEmptyStr(value)) return "";

		let formatVal = null;
		
		// hh:mm
		formatVal = value.match(/^(([0-1][0-9])|(2[0-3])):[0-5][0-9]/);
		if(formatVal) return formatVal[0];
		// hhmm => hh:mm으로 반환
		formatVal = value.match(/^(([0-1][0-9])|(2[0-3]))[0-5][0-9]/);
		if(formatVal) return formatVal[0].substring(0,2) + ":" + formatVal[0].substring(2);
		// hh:m
		formatVal = value.match(/^(([0-1][0-9])|(2[0-3])):[0-5]/);
		if(formatVal) return formatVal[0];
		// hh:
		formatVal = value.match(/^(([0-1][0-9])|(2[0-3])):/);
		if(formatVal) return formatVal[0];
		// hhm => hh:m 으로 반환
		formatVal = value.match(/^(([0-1][0-9])|(2[0-3]))[0-5]/);
		if(formatVal) return formatVal[0].substring(0,2) + ":" + formatVal[0].substring(2);
		// hh
		formatVal = value.match(/^(([0-1][0-9])|(2[0-3]))/);
		if(formatVal) return formatVal[0];
		// hh (0~2만 허용)
		formatVal = value.match(/^[0-2]/);
		if(formatVal) return formatVal[0];

		return "";
	}

    return (
		<input
			autoComplete="off"
			id={uuidv4()}
			className="basic-input"
			name={name || ""}
			onChange={timeInputChange}
			value={value ||""}
			readOnly={readOnly || !onChange ? true : false}
			placeholder={placeholder}
			type="text"
			style={style}
		/>
    );
}
